export const PERMS = {
    READ: 'vehicle_fuelings.read',
    CREATE: 'vehicle_fuelings.create',
    UPDATE: 'vehicle_fuelings.update',
    DELETE: 'vehicle_fuelings.delete',
    EXPORT: 'vehicle_fuelings.export',
    IMPORT: 'vehicle_fuelings.import',
}
